export const ZapMock = () => {
  return (
    <svg
      width="174"
      height="139"
      viewBox="0 0 174 139"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M86.5708 33.9209V111.169"
        stroke="#B5B2AA"
        strokeWidth="1.71662"
      />
      <rect
        x="1.23999"
        y="1.37109"
        width="171.52"
        height="52.22"
        rx="4.60483"
        fill="#FFFDF9"
        stroke="#D7D3C9"
      />
      <rect
        x="1.23999"
        y="85.0605"
        width="171.52"
        height="52.2151"
        rx="4.60483"
        fill="#FFFDF9"
        stroke="#D7D3C9"
      />
      <circle cx="15.6215" cy="15.1378" r="6.72766" fill="#ECE9DF" />
      <rect
        x="28.2058"
        y="11.7041"
        width="44.291"
        height="6.86646"
        rx="3.43323"
        fill="#ECE9DF"
      />
      <rect
        x="8.8938"
        y="28.5361"
        width="156.212"
        height="10.7685"
        rx="2"
        fill="#F5F3EB"
      />
      <path
        d="M86.5706 125.474C90.1749 125.474 93.6315 123.966 96.1801 121.284C98.7287 118.601 100.16 114.962 100.16 111.168C100.16 107.374 98.7287 103.736 96.1801 101.053C93.6315 98.3705 90.1749 96.8633 86.5706 96.8633C82.9663 96.8633 79.5097 98.3705 76.9611 101.053C74.4125 103.736 72.9807 107.374 72.9807 111.168C72.9807 114.962 74.4125 118.601 76.9611 121.284C79.5097 123.966 82.9663 125.474 86.5706 125.474V125.474ZM93.1889 109.738L85.2116 119.751V112.599H79.9523L87.9296 102.585V109.738H93.1889Z"
        fill="#D7D3C9"
      />
    </svg>
  );
};
